<template>
<div class="meWraper">
  <div class="inpBox">
    <input class="inpBox_inp" type="text" name="" value="" placeholder="请输入昵称" v-model="userName" maxlength="20">
    <img @click="clear()" v-show="userName" class="btn_clear" src="./../../assets/images/btn_clear.png" />
  </div>
  <div :class="['btn',userName?'btnActive':'',userName?'btn_color_'+common.theme:'']" @click="upDateUserName">
    保存
  </div>
</div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex';
import {
  updateUserInfo
} from '../../utils/api';
import util from '../../utils/util.js';

export default {
  name: 'me',
  components: {

  },
  computed: {
    ...mapState({
      common: state => state.common,
      userInfoData: state => state.common.userInfo,
      marketInfo: state => state.common.marketInfo,
      userId: state => state.common.userId,
      openId: state => state.common.openId
    })
  },
  data() {
    return {
      userName: ''
    };
  },
  filters: {

  },
  created() {
    this.userName = this.common.userInfo.userName
  },
  methods: {
    ...mapActions(['changeSomeInfo']),
    clear() {
      this.userName = ''
    },
    upDateUserName() {
      if (!this.userName) {
        util.showToast('请填写昵称!');
        return;
      } else if (/[^\w\u4e00-\u9fa5]/g.test(this.userName)) {
        util.showToast('昵称不能有特殊字符!');
        return;
      }

      let params = {
        userId: this.userId,
        userName: this.userName
      };

      updateUserInfo(params).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          this.changeSomeInfo({
            'name': 'userName',
            'val': this.userName
          })
          history.go(-1)
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/common.less';
.meWraper {
    width: 100%;
    background-color: @colore;
    flex: 1;
    overflow-x: hidden;
}
.inpBox {
    height: 100px;
    background-color: #ffffff;
    margin: 14px 0 60px;
    padding-left: 28px;
    box-sizing: border-box;
}
.inpBox_inp {
    height: 40px;
    width: 100%;
    line-height: 40px;
   // .fontSize(14px);
    font-size:28px;
    color: #333;
    margin: 30px 0;
}
input::-webkit-input-placeholder {
    color: #C9C9C9;
}
input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #C9C9C9;
}
input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #C9C9C9;
}
input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #C9C9C9;
}
.btn_clear {
    width: 44px;
    height: 44px;
    position: absolute;
    top: 42px;
    right: 28px;
}
.btn {
    height: 76px;
    width: 694px;
    border-radius: 4px;
    background-color: #DADADA;
    color: #ffffff;
    line-height: 76px;
    text-align: center;
   // .fontSize(16px);
    font-size:32px;
    margin: 0 28px;
}
.btnActive {
   // .commonBg();
    background-color: #1740DA;
    color: #ffffff;
}
</style>
